angular.module('impactx.cscontract').controller('CSCToleranceCtrl', [
    '$scope',
    CSCToleranceCtrl]);

function CSCToleranceCtrl($scope) {

    var self = this;

    var onChangeCheck = function(newVal, oldVal) {
        if(newVal !== oldVal){
            self.check();
        }
    };

    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.errorOnRelAndAbsOnly.value');
    }, onChangeCheck);

    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.relative.use.value');
    }, onChangeCheck);
    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.relative.low.value');
    }, onChangeCheck);
    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.relative.high.value');
    }, onChangeCheck);

    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.absolute.use.value');
    }, onChangeCheck);
    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.absolute.low.value');
    }, onChangeCheck);
    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.absolute.high.value');
    }, onChangeCheck);

    $scope.$watch(function(){
        return impactX.isDefined($scope, 'data.checkValue.value');
    }, onChangeCheck);
    
    self.check = function(){
        var checkValue = impactX.isDefined($scope, 'data.checkValue.value');
        if(checkValue || checkValue === 0){
            var join = $scope.data.errorOnRelAndAbsOnly.value;
            var relativeLow;
            var relativeHigh;
            var useRel = $scope.data.relative.use.value;
            if(useRel){
                if($scope.data.relative.high.value || $scope.data.relative.high.value===0){
                    relativeHigh = (checkValue * ($scope.data.relative.high.value)/100);
                }
                if($scope.data.relative.low.value || $scope.data.relative.low.value===0){
                    relativeLow = (checkValue * ($scope.data.relative.low.value)/100);
                }
            }
            var absoluteLow;
            var absoluteHigh;
            var useAbs = $scope.data.absolute.use.value;
            if(useAbs){
                if($scope.data.absolute.high.value || $scope.data.absolute.high.value===0){
                    absoluteHigh = $scope.data.absolute.high.value;
                }
                if($scope.data.absolute.low.value || $scope.data.absolute.low.value===0){
                    absoluteLow = $scope.data.absolute.low.value;
                }
            }
            if((relativeLow || relativeLow===0) && (absoluteLow || absoluteLow===0) && join) {
                $scope.data.lowValue = (relativeLow > absoluteLow ? relativeLow : absoluteLow);
            } else if((relativeLow || relativeLow===0) && (absoluteLow || absoluteLow===0)){
                $scope.data.lowValue = (relativeLow < absoluteLow ? relativeLow : absoluteLow);
            } else if(relativeLow || relativeLow===0){
                $scope.data.lowValue = relativeLow;
            } else if(absoluteLow || absoluteLow===0){
                $scope.data.lowValue = absoluteLow;
            } else {
                $scope.data.lowValue = undefined;
            }

            if((relativeHigh || relativeHigh===0) && (absoluteHigh || absoluteHigh===0) && join) {
                $scope.data.highValue = (relativeHigh > absoluteHigh ? relativeHigh : absoluteHigh);
            } else if((relativeHigh || relativeHigh===0) && (absoluteHigh || absoluteHigh===0)){
                $scope.data.highValue = (relativeHigh < absoluteHigh ? relativeHigh : absoluteHigh);
            } else if(relativeHigh || relativeHigh===0){
                $scope.data.highValue = relativeHigh;
            } else if(absoluteHigh || absoluteHigh===0){
                $scope.data.highValue = absoluteHigh;
            } else {
                $scope.data.highValue = undefined;
            }

            if(!(useAbs && useRel)) {
                $scope.data.errorOnRelAndAbsOnly.value = false;
            }
        }
    };
    self.check();
    
    $scope.getMaxValue = function(){
        var checkValue = Number(impactX.isDefined($scope, 'data.checkValue.value'));

        if(checkValue || checkValue === 0)
        {
            var high, low;
            
            var relativeLow;
            var relativeHigh;
            var useRel = $scope.data.relative.use.value;
            if (useRel) {
                if ($scope.data.relative.high.value || $scope.data.relative.high.value === 0) {
                    relativeHigh = (checkValue * ($scope.data.relative.high.value) / 100);
                }
                if ($scope.data.relative.low.value || $scope.data.relative.low.value === 0) {
                    relativeLow = (checkValue * ($scope.data.relative.low.value) / 100);
                }
            }
            var absoluteLow;
            var absoluteHigh;
            var useAbs = $scope.data.absolute.use.value;
            if (useAbs) {
                if ($scope.data.absolute.high.value || $scope.data.absolute.high.value === 0) {
                    absoluteHigh = Number($scope.data.absolute.high.value);
                }
                if ($scope.data.absolute.low.value || $scope.data.absolute.low.value === 0) {
                    absoluteLow = Number($scope.data.absolute.low.value);
                }
            }
            if ((relativeLow || relativeLow === 0) && (absoluteLow || absoluteLow === 0)) {
                low = (relativeLow > absoluteLow ? relativeLow : absoluteLow);
            }
            else if (relativeLow || relativeLow === 0) {
                low = relativeLow;
            }
            else if (absoluteLow || absoluteLow === 0) {
                low = absoluteLow;
            }
            else {
                low = undefined;
            }

            if ((relativeHigh || relativeHigh === 0) && (absoluteHigh || absoluteHigh === 0)) {
                high = (relativeHigh > absoluteHigh ? relativeHigh : absoluteHigh);
            }
            else if (relativeHigh || relativeHigh === 0) {
                high = relativeHigh;
            }
            else if (absoluteHigh || absoluteHigh === 0) {
                high = absoluteHigh;
            }
            else {
                high = undefined;
            }
            
            return Math.abs(checkValue+high) > Math.abs(checkValue-low) ? Math.abs(checkValue+high) : Math.abs(checkValue-low);
        }
        return 0;
    };
}